import { SET_COUNTRIES } from '../actions/actions';
import produce from 'immer';

const INITIAL_STATE = {
  countries: []
};

export default function countriesReducer(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_COUNTRIES: {
        draft.countries = action.payload;
        break;
      }

      default:
        return state;
    }
  });
}
